import logic from "./logic";

const logicExport = [...logic]
export default logicExport;
